import types from './types';

export default payload => ({ type: types.RENAME_LABEL, payload });
